import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Resume from './components/Resume';
import SalesDashboard from './components/SalesDashboard';
// import CandleShop from './components/CandleShop';
import CategoryAnalysis from './components/AMZCategoryAnalysis';
import WarehouseOperationsAnalytics from './components/WarehouseOperationsAnalytics';
import MaterialZoneAnalytics from './components/materialZoneAnalytics';
import ProjectsPage from './components/ProjectsPage';
import EarlierAnalyticsWork from './components/EarlierAnalyticsWork';
import Experience from './components/Experience';
// import DevCoDataPlatform from './components/DevCoDataPlatform';

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sales-dashboard" element={<SalesDashboard />} />
        <Route path="/warehouse-analytics"element={<WarehouseOperationsAnalytics />}/>
        <Route path="/material-zone-analytics" element={<MaterialZoneAnalytics />}/>
        <Route path="/amz-category-analysis" element={<CategoryAnalysis />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/earlier-analytics-work" element={<EarlierAnalyticsWork />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/resume" element={<Resume />} />
        {/* <Route path="/projects/websites/candle-shop" element={<CandleShop />} /> */}
        {/* TODO(Garrett): uncomment when mockup is filled in */}
        {/* <Route path="/devco-data-platform" element={<DevCoDataPlatform />} /> */}

        {/* Redirects for retired/renamed routes */}
        <Route path="/projects/data-processing" element={<Navigate to="/projects" replace />} />
        <Route path="/projects/websites" element={<Navigate to="/projects" replace />} />
        <Route path="/picnic-table-shop" element={<Navigate to="/earlier-analytics-work" replace />} />
        <Route path="/projects/websites/Bellevue-bank" element={<Navigate to="/earlier-analytics-work" replace />} />
        <Route path="/certificates" element={<Navigate to="/" replace />} />
        <Route path="/food-facts-dashboard" element={<Navigate to="/projects" replace />} />
        <Route path="/about" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
